import { render, staticRenderFns } from "./FormPassword.vue?vue&type=template&id=447d2588"
import script from "./FormPassword.vue?vue&type=script&lang=js"
export * from "./FormPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports